export { default } from "./DealsPromosNoResults";
